export default "__VITE_ASSET__mHkb80z___"